module.exports = __webpack_public_path__ + "static/img/2.fd229e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/brand/2.png
// module id = qCWk
// module chunks = 45